module.exports = __webpack_public_path__ + "staticesp/media/exposiesp.c37adff8.png";